import axios from '../../config/axiosConfig';
import { CREATE_PIPE_TYPE, GET_PIPE_TYPE, PIPE_TYPE_REQUEST, DELETE_PIPE_TYPE, 
UPDATE_PIPE_TYPE, PIPE_TYPE_REQUEST_FAILURE, GET_PIPE_TYPE_PAGE } from '../types';
import { addMasterInOption, updateMasterInOption } from './master-options-actions';

export const getPipeTypesWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PIPE_TYPE_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
      };
      return axios.get("/pipe-type/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PIPE_TYPE_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PIPE_TYPE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PIPE_TYPE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getPipeTypes = (commonMaster) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: PIPE_TYPE_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id };
            if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            }
            if (commonMaster !== undefined) {
                params = {
                  ...params,
                  companyId: commonMaster ? undefined : auth.company?.id
                };
            }
            return axios.get('/pipe-type/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_PIPE_TYPE, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: PIPE_TYPE_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_TYPE_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createPipeType = (data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const { pipeTypes } = getState();
            dispatch({ type: PIPE_TYPE_REQUEST });

            return axios.post('/pipe-type/add', data,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then( async (response) => {
                    if (response.data) {
                        dispatch({ type: CREATE_PIPE_TYPE, payload: response.data });
                        // Re-fetch the current page to get updated data
                        await dispatch(getPipeTypesWithPagination(
                            pipeTypes.page || 1,           // current page
                            pipeTypes.pageSize || 10,      // current page size
                            undefined,                  // include
                            pipeTypes.search || '',        // current search
                            undefined,                  // searchCols
                            pipeTypes.where || {},         // current filters
                            true                        // addTotal
                        ));
                        dispatch(addMasterInOption('pipeTypes', response.data));
                    } else {
                        dispatch({ type: PIPE_TYPE_REQUEST_FAILURE, error: 'Pipe Type create failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: PIPE_TYPE_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_TYPE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updatePipeType = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const { pipeTypes } = getState();
            dispatch({ type: PIPE_TYPE_REQUEST });
            return axios.put('/pipe-type/update', { id, data }, { params: { userId: auth.user?.id }}).then( async (response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_PIPE_TYPE, payload: { id, data: response.data } });
                    // Re-fetch the current page to get updated data
                    await dispatch(getPipeTypesWithPagination(
                        pipeTypes.page || 1,           // current page
                        pipeTypes.pageSize || 10,      // current page size
                        undefined,                  // include
                        pipeTypes.search || '',        // current search
                        undefined,                  // searchCols
                        pipeTypes.where || {},         // current filters
                        true                        // addTotal
                    ));
                    dispatch(updateMasterInOption('pipeTypes', id, response.data));
                } else {
                    dispatch({ type: PIPE_TYPE_REQUEST_FAILURE, error: 'Pipe Type update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: PIPE_TYPE_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_TYPE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deletePipeType = (id) => {
    return async (dispatch, getState) => {
        try {
            const { pipeTypes } = getState();
            dispatch({ type: PIPE_TYPE_REQUEST });
            return axios.delete(`/pipe-type/delete/${id}`).then( async (response) => {
                if (response.data) {
                    dispatch({ type: DELETE_PIPE_TYPE, id: id });
                    // Re-fetch the current page to get updated data
                    await dispatch(getPipeTypesWithPagination(
                        pipeTypes.page || 1,           // current page
                        pipeTypes.pageSize || 10,      // current page size
                        undefined,                  // include
                        pipeTypes.search || '',        // current search
                        undefined,                  // searchCols
                        pipeTypes.where || {},         // current filters
                        true                        // addTotal
                    ));
                    dispatch(updateMasterInOption('pipeTypes', id));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: PIPE_TYPE_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_TYPE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};